import { render, staticRenderFns } from "./push-notifications.vue?vue&type=template&id=1363e804&"
import script from "./push-notifications.vue?vue&type=script&lang=js&"
export * from "./push-notifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports